var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"component-status-label font-weight-bold",class:_vm.allcaps? 'text-uppercase' : false},[_vm._t("status",[_c('CircleStatus',{attrs:{"color":_vm.statusColor}},[_vm._t("default",[_vm._v("default label")])],2)])],2)}
var staticRenderFns = []

export { render, staticRenderFns }